const getFeatureCarouselUniqueCount = (emblaComponent) => {
  return Number(emblaComponent.getAttribute('data-unique-slides'));
};

const rebuildFeatureCarouselDots = (emblaComponent, emblaApi) => {
  const uniqueCount = getFeatureCarouselUniqueCount(emblaComponent);
  const dotsNode = emblaComponent.querySelector('.embla__dots');
  if (!dotsNode || !uniqueCount || uniqueCount < 2) return [];

  const totalSlides = emblaApi.slideNodes().length;
  if (totalSlides <= uniqueCount) return Array.from(dotsNode.querySelectorAll('.embla__dot'));

  dotsNode.innerHTML = Array.from({ length: uniqueCount }, () => {
    return '<button aria-label="carousel pagination button" class="embla__dot" type="button"></button>';
  }).join('');

  const dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
  dotNodes.forEach((dotNode, index) => {
    dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false);
  });

  return dotNodes;
};

const syncFeatureCarouselDots = (emblaApi, dotNodes, uniqueCount) => {
  if (!dotNodes.length || !uniqueCount) return;

  const selected = emblaApi.selectedScrollSnap() % uniqueCount;
  dotNodes.forEach((dotNode, index) => {
    dotNode.classList.toggle('embla__dot--selected', index === selected);
  });
};

const ensureFeatureCarouselApi = (emblaComponent) => {
  if (emblaComponent.emblaApi) return emblaComponent.emblaApi;
  if (typeof emblaComponent.init !== 'function') return null;

  emblaComponent.init();
  return emblaComponent.emblaApi || null;
};

const initFeatureCarousel = (emblaComponent) => {
  if (!emblaComponent.classList.contains('feature-carousel__embla')) return;
  if (emblaComponent.dataset.featureCarouselReady === 'true') return;

  const uniqueCount = getFeatureCarouselUniqueCount(emblaComponent);
  let dotNodes = [];

  const refreshDots = (emblaApi) => {
    dotNodes = rebuildFeatureCarouselDots(emblaComponent, emblaApi);
    syncFeatureCarouselDots(emblaApi, dotNodes, uniqueCount);
  };

  const settle = () => {
    const emblaApi = ensureFeatureCarouselApi(emblaComponent);
    if (!emblaApi) return false;

    emblaApi.reInit();
    refreshDots(emblaApi);

    // Embla emits `init` on a timeout after construction and can rebuild default dots after us.
    window.setTimeout(() => {
      refreshDots(emblaApi);
    }, 0);

    return true;
  };

  const bind = (emblaApi) => {
    emblaApi.on('init', () => refreshDots(emblaApi));
    emblaApi.on('reInit', () => refreshDots(emblaApi));
    emblaApi.on('select', () => syncFeatureCarouselDots(emblaApi, dotNodes, uniqueCount));
    emblaComponent.dataset.featureCarouselReady = 'true';
  };

  const waitForApi = () => {
    const emblaApi = ensureFeatureCarouselApi(emblaComponent);
    if (!emblaApi) {
      requestAnimationFrame(waitForApi);
      return;
    }

    bind(emblaApi);
    settle();

    requestAnimationFrame(() => {
      settle();
    });

    window.addEventListener(
      'load',
      () => {
        settle();
      },
      { once: true }
    );
  };

  waitForApi();
};

const initFeatureCarousels = (root = document) => {
  root
    .querySelectorAll('embla-component.feature-carousel__embla')
    .forEach(initFeatureCarousel);
};

document.addEventListener('DOMContentLoaded', () => initFeatureCarousels());

document.addEventListener('shopify:section:load', (event) => {
  const section = document.querySelector(`#shopify-section-${event.detail.sectionId}`);
  if (!section) return;

  section
    .querySelectorAll('embla-component.feature-carousel__embla')
    .forEach((emblaComponent) => {
      delete emblaComponent.dataset.featureCarouselReady;
    });

  initFeatureCarousels(section);
});
